define("shared/components/shared/ui/group-item", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service"], function (_exports, _component, _templateFactory, _component2, _object, _service) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <li class="o--dropBody__item">
    <Shared::Ui::Button
      class="u--p__0 o--dropBody__link u--ellipsis"
      @type="unstyled"
      @onClick={{this.transition}}
    >
      <Shared::Ui::GroupAvatar @group={{@group}} />
    </Shared::Ui::Button>
    {{#if @isSelected}}
      {{svg-jar "check" class="o--icon cNA--group__status"}}
    {{/if}}
  </li>
  
  */
  {
    "id": "s2XbKnaF",
    "block": "[[[10,\"li\"],[14,0,\"o--dropBody__item\"],[12],[1,\"\\n  \"],[8,[39,0],[[24,0,\"u--p__0 o--dropBody__link u--ellipsis\"]],[[\"@type\",\"@onClick\"],[\"unstyled\",[30,0,[\"transition\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[39,1],null,[[\"@group\"],[[30,1]]],null],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"],[41,[30,2],[[[1,\"    \"],[1,[28,[35,3],[\"check\"],[[\"class\"],[\"o--icon cNA--group__status\"]]]],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\"]],[\"@group\",\"@isSelected\"],false,[\"shared/ui/button\",\"shared/ui/group-avatar\",\"if\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/ui/group-item.hbs",
    "isStrictMode": false
  });

  let GroupItemComponent = (_class = class GroupItemComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "router", _descriptor, this);

      _initializerDefineProperty(this, "userAgent", _descriptor2, this);
    }

    transition() {
      this.args.closeMenu();

      if (this.userAgent.device.isMobile) {
        this.router.transitionTo('cluster.linkinbio', this.args.group.slug);
      } else {
        this.router.transitionTo('cluster.schedule', this.args.group.slug);
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userAgent", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "transition", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "transition"), _class.prototype)), _class);
  _exports.default = GroupItemComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, GroupItemComponent);
});